import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import HeaderProfileSection from "../HeaderProfileSection";
import DailyQuestionCard from "./DailyQuestionCard";
import DailyQuestionModal from "./DailyQuestionModal";
import { useDailyQuestions } from "../../hooks/useDailyQuestions";
import { getStoredUser } from "../../utils/authStorage";
import { buildQuestionBankFlowState, getStoredQuestionBankFlowState, persistQuestionBankFlowState } from "../../questionBank/qbankFlowState";

import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import "../DashboardFavoriteExam.css";
import "./Dailyquestion.css";
import { CONTENT_ROUTES } from "../contentRoutes";

const DailyQuestion = () => {
  const [popupCard, setPopupCard] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const flowState = useMemo(
    () => buildQuestionBankFlowState(location.state, getStoredQuestionBankFlowState()),
    [location.state]
  );
  const listState = flowState?.listQueryState || {};
  const [page, setPage] = useState(() => Math.max(1, Number(listState.currentPage) || 1));
  const storedUser = getStoredUser();
  const selectedLanguage = String(
    flowState?.selected_lang || flowState?.language || storedUser?.content_language || storedUser?.language || "EN"
  ).toUpperCase().startsWith("HI") ? "HI" : "EN";
  const { data, isLoading, isError, error } = useDailyQuestions({
    page,
    perPage: 20,
    language: selectedLanguage,
  });
  const questions = data?.questions || [];
  const isInitialLoading = isLoading && !data;
  const pagination = data?.pagination || {
    currentPage: page,
    totalPages: 1,
    totalRecords: 0,
    perPage: 20,
  };
  const screenState = useMemo(
    () => buildQuestionBankFlowState({
      ...flowState,
      listQueryState: { ...listState, currentPage: page },
    }),
    [flowState, listState, page]
  );

  useEffect(() => {
    persistQuestionBankFlowState(screenState);
  }, [screenState]);

  const closePopup = () => {
    setPopupCard(null);
  };

  const openReview = (question) => {
    const detailState = buildQuestionBankFlowState({
      ...screenState,
      selectedDailyQuestion: { id: Number(question.daily_question_id || 0) },
      daily_question_id: Number(question.daily_question_id || 0),
      selected_lang: selectedLanguage,
      qbankBackTarget: { pathname: CONTENT_ROUTES.dailyQuestions, state: screenState },
    });

    persistQuestionBankFlowState(detailState);
    navigate(CONTENT_ROUTES.dailyQuestionDetail, { state: detailState });
  };

  return (
    <>
      <style>{`
        .homeDashboard-wrapper .page-content {
          padding-right: 0;
        }
        .question-padding{
            padding:20px 0;
        }
        @media (max-width: 767.98px) {
       .qb {
          gap: 0;
        }
      .question-padding {
       padding: 12px 0;
     }
      }
      `}</style>

      <HomeDashboardLayout showHeader={false}>
        <section className="qb page-padding">
          <div className="hideProfile-page">
            
            {/* Page Header */}
            <div className="categories-page-header mb-0">
              <div>
                <button
                  type="button"
                  className="categories-back-button"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
              </div>

              <div>
                <h4 className="d-flex categories-page-title">
                  Daily Question Bank
                </h4>
              </div>

              <div>
                <HeaderProfileSection />
              </div>
            </div>
          </div>

          <div className="qb-body question-padding">
            
            {/* Header */}
            <div className="d-flex align-items-center justify-content-center">
              <div className="qb-copy daily-questions-card">
                
                <div className="qb-loc">
                  {isInitialLoading ? <span className="daily-question-hero-skeleton daily-question-hero-skeleton--location" /> : <>Himachal Pradesh <span>/</span> Daily Questions</>}
                </div>

                <h1 className="qb-title">
                  {isInitialLoading ? (
                    <span className="daily-question-title-shimmer" aria-label="Loading questions" />
                  ) : (
                    <>{pagination.totalRecords || questions.length} questions<span> available </span></>
                  )}
                </h1>

                <p className="qb-sub">
                  {isInitialLoading ? <span className="daily-question-hero-skeleton daily-question-hero-skeleton--subtitle" /> : "Attempted questions open in read mode with answer review."}
                </p>

              </div>
            </div>

            {/* Daily Question Cards */}
            <DailyQuestionCard
              onOpenPopup={setPopupCard}
              onReview={openReview}
              questions={questions}
              isLoading={isInitialLoading}
              isError={isError}
              errorMessage={error?.response?.data?.message || error?.message}
              page={pagination.currentPage}
              perPage={pagination.perPage}
              totalPages={pagination.totalPages}
              onPageChange={setPage}
            />

          </div>
        </section>
      </HomeDashboardLayout>

      {/* Modal OUTSIDE HomeDashboardLayout */}
      <DailyQuestionModal
        open={Boolean(popupCard)}
        onClose={closePopup}
      />
    </>
  );
};

export default DailyQuestion;
